export const CLEAR_ERROR = 'CLEAR_ERROR';
export default function clearError(id) {
  return { type: CLEAR_ERROR, id };
}
